import { Widget } from '@neptune/shared/widgets-domain';
import {
  DynamicSectionWidget,
  isDynamicSectionWidget,
} from '@neptune/widgets/dynamic-section-domain';

import { isSectionWidget, SectionWidget } from './section-widget';

export type SectionVariant = SectionWidget | DynamicSectionWidget;

export const isSectionVariantWidget = (widget: Widget): widget is SectionVariant => {
  return isSectionWidget(widget) || isDynamicSectionWidget(widget);
};

export const withoutSectionFolding = (widget: Widget): Widget => {
  return isSectionVariantWidget(widget)
    ? { ...widget, options: { ...widget.options, folded: undefined } }
    : widget;
};
